<script lang="jsx">
import BuyNow from './buy-now.vue';
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...{...this.$props, ...this.$attrs }} />;
    return null;
  },
};
</script>
